module.exports = __webpack_public_path__ + "img/icon-1.5879d414.png";